import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PropertySet } from '@miq/domain/property-sets';

import { PropertySetQuery, PropertySetsHttpService, PSSearchQuery } from '../services/http/property-sets-http.service';
import { Filter } from '@cbre/components';

@Injectable()
export class PropertySetListService {
  constructor(private psHttpService: PropertySetsHttpService) {}

  public search(query: PropertySetQuery): Observable<PropertySet[]> {
    return this.psHttpService.findAll(query);
  }

  public delete(id: number): Observable<void> {
    return this.psHttpService.delete(id);
  }

  public findByFilter(
    filters: Filter[],
    options: Pick<PSSearchQuery, 'limit' | 'offset'> = { limit: 10, offset: 0 }
  ): Observable<PropertySet[]> {
    return this.psHttpService.getPropertySetByFilters(filters, options);
  }
}
